import { Controller } from '@hotwired/stimulus'
import Awesomplete from 'awesomplete'
import 'awesomplete/awesomplete.css'

export default class extends Controller {
  static targets = ['modal', 'input', 'send', 'saveCheckbox']
  static values = {
    choices: Array,
    baseUrl: String,
    token: String
  }

  connect () {
    this.awesomplete = new Awesomplete(this.inputTarget, {
      list: this.choicesValue,
      minChars: 0,
      autoFirst: true,
      filter: (text, input) => {
        return this.showAll || Awesomplete.FILTER_CONTAINS(text, input)
      }
    })

    this.inputTarget.parentNode.classList.add('w-full')
  }

  disconnect () {
    this.awesomplete?.destroy()
  }

  open () {
    this.modalTarget.classList.remove('hidden')
  }

  close () {
    this.modalTarget.classList.add('hidden')
  }

  toggleDropdown () {
    this.showAll = true
    this.awesomplete.evaluate()
    this.inputTarget.focus()
    this.showAll = false
  }

  send (event) {
    event.preventDefault()
    event.stopPropagation()

    const email = this.inputTarget.value.trim()
    if (!email) {
      alert('Please enter a valid email address.')
      return
    }

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.baseUrlValue

    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = this.tokenValue
    form.appendChild(csrfInput)

    const emailInput = document.createElement('input')
    emailInput.type = 'hidden'
    emailInput.name = 'customer_email'
    emailInput.value = email
    form.appendChild(emailInput)

    const saveInput = document.createElement('input')
    saveInput.type = 'hidden'
    saveInput.name = 'save_to_customer'
    saveInput.value = this.saveCheckboxTarget.checked ? '1' : '0'
    form.appendChild(saveInput)

    document.body.appendChild(form)
    form.setAttribute('data-turbo', 'false')
    form.submit()
  }
}
